module.exports = __webpack_public_path__ + "img/logbo-faq2.07d65d46.png";